import axios from 'axios'
import Token from '../module/token'
import YunLinked from 'yunlinked'

Token.en()
const http = axios.create({
  baseURL: process.env.VUE_APP_API_SUB_PATH
})
http.interceptors.request.use(config => {
  config.headers.common = {
          'traceId': YunLinked.mainGetId(),
          deviceId: YunLinked.mainGetDeviceId(),
  }
  return config
})
http.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  err => Promise.reject(err)
)

export const getShopListApi = data => {
  return http({
    url: `/prod/order/v1/kd/hall`,
    method: 'post',
    data
  })
}

export const getGoodsListApi = data => {
  return http({
    url: `/prod/order/v1/kd/skuList`,
    method: 'post',
    data
  })
}

export const getGoodInfoApi = data => {
  return http({
    url: `/prod/order/v1/kd/skuDetail`,
    method: 'post',
    data
  })
}
// /prod/order/v1/kd/skuList
export const broadbandSubmitApi = data => {
  return http({
    url: `/prod/order/v1/package`,
    method: 'post',
    data
  })
}
// 获取城市的经纬度
export const getLocationApi = data => {
  return http({
    url: '/card/common/v2/get/location',
    method: 'post',
    data
  })
}

export const getOcationCityApi = params => {
  return http({
    url: '/card/common/v2/location/city',
    method: 'get',
    params
  })
}

// 获取城市的经纬度
export const getphoneApi = data => {
  return http({
    url: '/prod/order/v1/kd/select',
    method: 'post',
    data
  })
}

// 判断手机号是否本网
export const isThiswebsitePhone = params => {
  return http({
    url: '/prod/order/v1/check/phoneOperator',
    method: 'get',
    params
  })
}

// 
export const goosSpecifications = data => {
  return http({
    url: '/prod/order/v1/kd/spuInfo',
    method: 'post',
    data
  })
}

export const goosSpecificationsDetail = data => {
  return http({
    url: '/prod/order/v1/kd/skuDetail',
    method: 'post',
    data
  })
}

